import { SessionReportRow, SessionReportSummaryBase } from './types';

/** 카드가 선택한 서버 필드를 끝까지 유지한다. 강사별로 환불/기타 조정을 다시 선택하지 않는다. */
export type FlowMetric = 'prevRemaining' | 'registeredSessions' | 'progressed' | 'handoffSessions' | 'refundSessions' | 'closed' | 'removedSessions' | 'remaining';
export type FlowEvidenceSelection = { metric: FlowMetric; label: string };

export const flowSummaryValue = (summary: SessionReportSummaryBase, metric: FlowMetric) =>
    metric === 'removedSessions' ? summary.refundSessions + (summary.closed ?? 0)
        : metric === 'progressed' ? -summary.progressed : summary[metric] ?? 0;

export const flowRowValue = (row: SessionReportRow, metric: FlowMetric) =>
    metric === 'removedSessions' ? row.refundSessions + (row.otherAdjustments?.closed ?? 0)
        : metric === 'closed' ? row.otherAdjustments.closed : metric === 'progressed' ? -row.progressed : row[metric];

/** 부호가 있는 이동·차감도 규모가 큰 항목부터 보여 준다. 같은 값은 원래 순서를 지킨다. */
export const largestFlowFirst = <T,>(items: T[], value: (item: T) => number) =>
    items.filter((item) => value(item) !== 0).sort((a, b) => Math.abs(value(b)) - Math.abs(value(a)));
